import React from 'react';
import style from './index.scss';

export default ({
    className = '',
    classNames = {},
    children,
    ...props
}) => (
    <ul className={`${style.list} ${className}`} {...props}>
        {React.Children.map(children, (component, index) => (
            <li key={`list-item-${index}`} className={`${style.item} ${classNames.item || ''}`}>
                {component}
            </li>
        ))}
    </ul>
);
